import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLang, SUPPORTED } from '../config/languages';

// Pre-import all translation files so they're available synchronously (required for SSR/static export).
import enHeader from './locales/en/header.json';
import enHome from './locales/en/home.json';
import enFooter from './locales/en/footer.json';
import enContact from './locales/en/contact.json';
import enPrivacy from './locales/en/privacy.json';
import enBlog from './locales/en/blog.json';
import enSolutions from './locales/en/solutions.json';
import enPricing from './locales/en/pricing.json';
import enSupport from './locales/en/support.json';
import enNewsletter from './locales/en/newsletter.json';
import enVs from './locales/en/vs.json';
import enCallToAction from './locales/en/call_to_action.json';

import srHeader from './locales/sr/header.json';
import srHome from './locales/sr/home.json';
import srFooter from './locales/sr/footer.json';
import srContact from './locales/sr/contact.json';
import srPrivacy from './locales/sr/privacy.json';
import srBlog from './locales/sr/blog.json';
import srSolutions from './locales/sr/solutions.json';
import srPricing from './locales/sr/pricing.json';
import srSupport from './locales/sr/support.json';
import srNewsletter from './locales/sr/newsletter.json';
import srVs from './locales/sr/vs.json';
import srCallToAction from './locales/sr/call_to_action.json';

import deHeader from './locales/de/header.json';
import deHome from './locales/de/home.json';
import deFooter from './locales/de/footer.json';
import deContact from './locales/de/contact.json';
import dePrivacy from './locales/de/privacy.json';
import deBlog from './locales/de/blog.json';
import deSolutions from './locales/de/solutions.json';
import dePricing from './locales/de/pricing.json';
import deSupport from './locales/de/support.json';
import deNewsletter from './locales/de/newsletter.json';
import deVs from './locales/de/vs.json';
import deCallToAction from './locales/de/call_to_action.json';

import esHeader from './locales/es/header.json';
import esHome from './locales/es/home.json';
import esFooter from './locales/es/footer.json';
import esContact from './locales/es/contact.json';
import esPrivacy from './locales/es/privacy.json';
import esBlog from './locales/es/blog.json';
import esSolutions from './locales/es/solutions.json';
import esPricing from './locales/es/pricing.json';
import esSupport from './locales/es/support.json';
import esNewsletter from './locales/es/newsletter.json';
import esVs from './locales/es/vs.json';
import esCallToAction from './locales/es/call_to_action.json';

import frHeader from './locales/fr/header.json';
import frHome from './locales/fr/home.json';
import frFooter from './locales/fr/footer.json';
import frContact from './locales/fr/contact.json';
import frPrivacy from './locales/fr/privacy.json';
import frBlog from './locales/fr/blog.json';
import frSolutions from './locales/fr/solutions.json';
import frPricing from './locales/fr/pricing.json';
import frSupport from './locales/fr/support.json';
import frNewsletter from './locales/fr/newsletter.json';
import frVs from './locales/fr/vs.json';
import frCallToAction from './locales/fr/call_to_action.json';

import itHeader from './locales/it/header.json';
import itHome from './locales/it/home.json';
import itFooter from './locales/it/footer.json';
import itContact from './locales/it/contact.json';
import itPrivacy from './locales/it/privacy.json';
import itBlog from './locales/it/blog.json';
import itSolutions from './locales/it/solutions.json';
import itPricing from './locales/it/pricing.json';
import itSupport from './locales/it/support.json';
import itNewsletter from './locales/it/newsletter.json';
import itVs from './locales/it/vs.json';
import itCallToAction from './locales/it/call_to_action.json';

import ptHeader from './locales/pt/header.json';
import ptHome from './locales/pt/home.json';
import ptFooter from './locales/pt/footer.json';
import ptContact from './locales/pt/contact.json';
import ptPrivacy from './locales/pt/privacy.json';
import ptBlog from './locales/pt/blog.json';
import ptSolutions from './locales/pt/solutions.json';
import ptPricing from './locales/pt/pricing.json';
import ptSupport from './locales/pt/support.json';
import ptNewsletter from './locales/pt/newsletter.json';
import ptVs from './locales/pt/vs.json';
import ptCallToAction from './locales/pt/call_to_action.json';

import nlHeader from './locales/nl/header.json';
import nlHome from './locales/nl/home.json';
import nlFooter from './locales/nl/footer.json';
import nlContact from './locales/nl/contact.json';
import nlPrivacy from './locales/nl/privacy.json';
import nlBlog from './locales/nl/blog.json';
import nlSolutions from './locales/nl/solutions.json';
import nlPricing from './locales/nl/pricing.json';
import nlSupport from './locales/nl/support.json';
import nlNewsletter from './locales/nl/newsletter.json';
import nlVs from './locales/nl/vs.json';
import nlCallToAction from './locales/nl/call_to_action.json';

import jaHeader from './locales/ja/header.json';
import jaHome from './locales/ja/home.json';
import jaFooter from './locales/ja/footer.json';
import jaContact from './locales/ja/contact.json';
import jaPrivacy from './locales/ja/privacy.json';
import jaBlog from './locales/ja/blog.json';
import jaSolutions from './locales/ja/solutions.json';
import jaPricing from './locales/ja/pricing.json';
import jaSupport from './locales/ja/support.json';
import jaNewsletter from './locales/ja/newsletter.json';
import jaVs from './locales/ja/vs.json';
import jaCallToAction from './locales/ja/call_to_action.json';

import plHeader from './locales/pl/header.json';
import plHome from './locales/pl/home.json';
import plFooter from './locales/pl/footer.json';
import plContact from './locales/pl/contact.json';
import plPrivacy from './locales/pl/privacy.json';
import plBlog from './locales/pl/blog.json';
import plSolutions from './locales/pl/solutions.json';
import plPricing from './locales/pl/pricing.json';
import plSupport from './locales/pl/support.json';
import plNewsletter from './locales/pl/newsletter.json';
import plVs from './locales/pl/vs.json';
import plCallToAction from './locales/pl/call_to_action.json';

const NS = ['header', 'home', 'footer', 'contact', 'privacy', 'blog', 'solutions', 'pricing', 'support', 'newsletter', 'vs', 'call_to_action'] as const;

const resources = {
  en: { header: enHeader, home: enHome, footer: enFooter, contact: enContact, privacy: enPrivacy, blog: enBlog, solutions: enSolutions, pricing: enPricing, support: enSupport, newsletter: enNewsletter, vs: enVs, call_to_action: enCallToAction },
  sr: { header: srHeader, home: srHome, footer: srFooter, contact: srContact, privacy: srPrivacy, blog: srBlog, solutions: srSolutions, pricing: srPricing, support: srSupport, newsletter: srNewsletter, vs: srVs, call_to_action: srCallToAction },
  de: { header: deHeader, home: deHome, footer: deFooter, contact: deContact, privacy: dePrivacy, blog: deBlog, solutions: deSolutions, pricing: dePricing, support: deSupport, newsletter: deNewsletter, vs: deVs, call_to_action: deCallToAction },
  es: { header: esHeader, home: esHome, footer: esFooter, contact: esContact, privacy: esPrivacy, blog: esBlog, solutions: esSolutions, pricing: esPricing, support: esSupport, newsletter: esNewsletter, vs: esVs, call_to_action: esCallToAction },
  fr: { header: frHeader, home: frHome, footer: frFooter, contact: frContact, privacy: frPrivacy, blog: frBlog, solutions: frSolutions, pricing: frPricing, support: frSupport, newsletter: frNewsletter, vs: frVs, call_to_action: frCallToAction },
  it: { header: itHeader, home: itHome, footer: itFooter, contact: itContact, privacy: itPrivacy, blog: itBlog, solutions: itSolutions, pricing: itPricing, support: itSupport, newsletter: itNewsletter, vs: itVs, call_to_action: itCallToAction },
  pt: { header: ptHeader, home: ptHome, footer: ptFooter, contact: ptContact, privacy: ptPrivacy, blog: ptBlog, solutions: ptSolutions, pricing: ptPricing, support: ptSupport, newsletter: ptNewsletter, vs: ptVs, call_to_action: ptCallToAction },
  nl: { header: nlHeader, home: nlHome, footer: nlFooter, contact: nlContact, privacy: nlPrivacy, blog: nlBlog, solutions: nlSolutions, pricing: nlPricing, support: nlSupport, newsletter: nlNewsletter, vs: nlVs, call_to_action: nlCallToAction },
  ja: { header: jaHeader, home: jaHome, footer: jaFooter, contact: jaContact, privacy: jaPrivacy, blog: jaBlog, solutions: jaSolutions, pricing: jaPricing, support: jaSupport, newsletter: jaNewsletter, vs: jaVs, call_to_action: jaCallToAction },
  pl: { header: plHeader, home: plHome, footer: plFooter, contact: plContact, privacy: plPrivacy, blog: plBlog, solutions: plSolutions, pricing: plPricing, support: plSupport, newsletter: plNewsletter, vs: plVs, call_to_action: plCallToAction },
};

i18n.use(initReactI18next).init({
  // Keep the first client render identical to SSR. Language routes are applied
  // by LangInitializer after hydration; detecting from window here causes
  // "Home" vs "Accueil" hydration mismatches on localized pages.
  lng: defaultLang,
  fallbackLng: defaultLang,
  supportedLngs: SUPPORTED as unknown as string[],
  ns: NS as unknown as string[],
  defaultNS: 'header',
  resources,
  interpolation: { escapeValue: false },
  debug: false,
});

// Kept for backward compatibility - all namespaces are pre-loaded so this is a no-op.
export async function loadNamespaces(_lang: string, _namespaces: string[] = []) {}

export default i18n;
